import React, { type ReactNode } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl-next';
import EmptyState from '@atlaskit/empty-state';
import { type Props } from './types';
import messages from './messages';
import pagesEmptyStateIcon from '../icons/error.svg';
import {
	CROSS_JOIN_NUDGE_PROJECT_GATE,
	CROSS_JOIN_NUDGE_PROJECT_EXPERIMENT,
} from '../../../ui/cross-join/constants';
import { getTargetingGate, getExperimentValue } from '../../../common/feature-gates';
import mountTrackerFactory from '../../../common/analytics/mount-tracker-factory';
import ContactSupport from '../../../ui/project-pages-improvement/common/contact-support';
import CrossJoin from '../../../ui/cross-join/connected';

const MountTracker = mountTrackerFactory('serverErrorEmptySpace');

const ServerError = ({ type = 'server', intl: { formatMessage } }: Props) => {
	const isCrossJoinProjectExperimentEnabled = getTargetingGate(CROSS_JOIN_NUDGE_PROJECT_GATE);
	// Feature exposed event has been fired when users view lozenge & spotlight, so we disable this one
	const crossJoinNudgeExperimentCohort = isCrossJoinProjectExperimentEnabled
		? getExperimentValue(CROSS_JOIN_NUDGE_PROJECT_EXPERIMENT, 'not-enrolled', false)
		: 'not-enrolled';

	if (type === 'access') {
		return (
			<>
				<CrossJoin
					parentPageId={null}
					spaceKey={null}
					isCrossJoinProjectExperimentEnabled={isCrossJoinProjectExperimentEnabled}
					crossJoinProjectExperimentCohort={crossJoinNudgeExperimentCohort}
				/>
				<MountTracker type={type} />
			</>
		);
	}
	return (
		<>
			<EmptyState
				width="wide"
				imageUrl={pagesEmptyStateIcon}
				maxImageWidth={82}
				header={formatMessage(messages.heading)}
				description={
					<FormattedMessage
						{...messages.description}
						values={{
							link: (chunks: ReactNode) => <ContactSupport label={chunks} />,
						}}
					/>
				}
			/>
			<MountTracker type={type} />
		</>
	);
};

export default injectIntl(ServerError);
